<template>
  <FormBlock>
    <ExtraNationalityStatusSelect v-model="nationality.status" :has-past />
    <v-expand-transition>
      <div v-if="nationality.status != 'none'">
        <slot>
          <NationalitySelect v-model="nationality.country" hide-hint />
        </slot>
      </div>
    </v-expand-transition>
  </FormBlock>
</template>

<script setup lang="ts">
import type { ExtraNationality } from '~/types';

const nationality = defineModel<ExtraNationality>({ required: true });
defineProps<{
  hasPast?: boolean;
}>();
</script>